import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {removeNotification} from 'shared/actions/notifications';
import SimpleNotification from '../../src/components/notifications/simple-notification';
import ActionNotification from '../../src/components/notifications/action-notification';
import 'stylesheets/components/shared-notifications.scss';
import {Store} from 'src/types/store';

const Notifications = () => {
  const dispatch = useDispatch();

  const notifications = useSelector((state: Store) => state.notifications);

  const dismiss = (id) => dispatch(removeNotification(id));

  const iconForNotificationType = ({type}) => {
    switch (type) {
      case 'success':
        return 'check-r';
      case 'error':
        return '';
    }
  };

  const mapNotificationToComponent = (notification) => {
    const sharedProps = {
      dismiss: () => dismiss(notification.id),
      key: notification.id,
      text: notification.text,
      type: notification.type,
    };

    switch (notification.template) {
      case 'action':
        return (
          <ActionNotification
            {...sharedProps}
            strongText={notification.strongText}
            actionText={notification.actionText}
            action={notification.action}
          />
        );
      default:
        return (
          <SimpleNotification {...sharedProps} iconType={iconForNotificationType(notification)} />
        );
    }
  };

  // TODO: make this care about the duration and dispatch it's own removal
  return (
    <div className="shared-notifications">
      {notifications.map((notification) => mapNotificationToComponent(notification))}
    </div>
  );
};

export default Notifications;
